'use strict';

var SCROLL_STEP_RATIO = 0.85;
var INIT_ATTR = 'data-filter-bar-carousel-init';

/**
 * All Filters: scroll to top of the panel and focus the first refinement section.
 */
function focusFirstRefinementSection() {
    var drawer = document.querySelector('.refinement-bar.show');
    if (!drawer) {
        return;
    }

    var wrapper = drawer.querySelector('.refinements-wrapper');
    var firstCard = drawer.querySelector('.refinements .card.refinement:not(.refinement-sort)');
    if (!firstCard) {
        return;
    }

    if (wrapper) {
        wrapper.scrollTop = 0;
    }

    var toggle = firstCard.querySelector('.card-header .mobile-view .btn.title, .card-header .mobile-view button');
    if (toggle) {
        toggle.focus();
        return;
    }

    var focusable = firstCard.querySelector(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) {
        focusable.focus();
    }
}

/**
 * Focus the refinement block opened from the mobile filter bar.
 * @param {string} elem - data-elem value (e.g. refinement-color, refinement-sort)
 */
function focusRefinementBlock(elem) {
    var $target;
    if (!elem || elem === 'refinement-sort') {
        $target = document.getElementById('refinement-sort');
        if ($target) {
            var sortToggle = $target.querySelector('.card-header .mobile-view .btn, .card-header .btn');
            if (sortToggle) {
                sortToggle.focus();
            }
        }
        return;
    }
    if (elem === 'refinement-all-filters') {
        focusFirstRefinementSection();
        return;
    }
    $target = document.querySelector('.refinement-bar .refinements .card.refinement.' + elem);
    if (!$target) {
        return;
    }
    var toggle = $target.querySelector('.card-header .mobile-view .btn');
    if (toggle) {
        toggle.focus();
        return;
    }
    var focusable = $target.querySelector('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (focusable) {
        focusable.focus();
    }
}

/**
 * Focus the drawer footer Close or Apply control (Apply preferred when present).
 */
function focusDrawerCloseApply() {
    var drawer = document.querySelector('.refinement-bar.show');
    if (!drawer) {
        return;
    }
    var apply = drawer.querySelector('button.apply');
    var close = drawer.querySelector('button.close, button.close-refinement');
    var target = apply || close;
    if (target) {
        target.focus();
    }
}

/**
 * After a refinement Ajax update while the drawer stays open, move focus to Close / Apply.
 */
function scheduleFocusDrawerCloseApplyAfterAjax() {
    window.setTimeout(focusDrawerCloseApply, 150);
}

/**
 * Return focus to the filter bar button that opened the refinement drawer.
 * @param {string} [elem] - data-elem from the trigger button
 */
function focusFilterBarTrigger(elem) {
    var trigger;
    if (elem) {
        trigger = document.querySelector('button.open-refinement[data-elem="' + elem + '"]');
    }
    if (!trigger) {
        trigger = document.querySelector('.btn.filter-results');
    }
    if (trigger) {
        trigger.focus();
    }
}

/**
 * Schedule focus on the opened refinement block after the drawer is visible.
 * @param {string} elem - data-elem value
 */
function scheduleFocusRefinementBlock(elem) {
    var run = function () {
        focusRefinementBlock(elem);
    };

    if (elem === 'refinement-all-filters') {
        window.setTimeout(run, 350);
        return;
    }

    window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
    });
}

/**
 * Move selected carousel pills to the front; unselected pills follow in catalog order.
 * @param {HTMLElement} track - .filter-bar-carousel__track
 */
function rearrangeFilterButtons(track) {
    if (!track) {
        return;
    }

    var pills = Array.prototype.slice.call(track.querySelectorAll('button.open-refinement[data-elem]'));
    if (!pills.length) {
        return;
    }

    var active = [];
    var inactive = [];

    pills.forEach(function (btn) {
        if (btn.classList.contains('active')) {
            active.push(btn);
        } else {
            inactive.push(btn);
        }
    });

    active.concat(inactive).forEach(function (btn) {
        track.appendChild(btn);
    });

    var firstActive = track.querySelector('button.open-refinement.active');
    if (firstActive) {
        firstActive.scrollIntoView({ inline: 'start', block: 'nearest' });
    } else {
        track.scrollLeft = 0;
    }
}

/**
 * Allow full re-init after Ajax replaces carousel markup.
 */
function clearInitFlags() {
    document.querySelectorAll('[data-filter-bar-carousel]').forEach(function (carousel) {
        carousel.removeAttribute(INIT_ATTR);
    });
}

/**
 * @param {HTMLElement} carousel - .filter-bar-carousel root
 */
function updateNavState(carousel) {
    var track = carousel.querySelector('.filter-bar-carousel__track');
    var prev = carousel.querySelector('.filter-bar-carousel__btn--prev');
    var next = carousel.querySelector('.filter-bar-carousel__btn--next');
    if (!track || !prev || !next) return;

    var overflows = track.scrollWidth > track.clientWidth + 2;
    carousel.classList.toggle('filter-bar-carousel--overflow', overflows);

    if (!overflows) {
        prev.hidden = true;
        next.hidden = true;
        prev.setAttribute('aria-hidden', 'true');
        next.setAttribute('aria-hidden', 'true');
        prev.disabled = true;
        next.disabled = true;
        return;
    }

    prev.hidden = false;
    next.hidden = false;
    prev.removeAttribute('aria-hidden');
    next.removeAttribute('aria-hidden');

    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

    prev.disabled = atStart;
    next.disabled = atEnd;
}

/**
 * Re-measure overflow after layout (fonts, sticky header, flex).
 * @param {HTMLElement} carousel - .filter-bar-carousel root
 */
function scheduleNavUpdate(carousel) {
    window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
            updateNavState(carousel);
        });
    });
}

/**
 * @param {HTMLElement} track - scrollable track
 * @param {number} direction - -1 or 1
 */
function scrollTrack(track, direction) {
    var delta = Math.round(track.clientWidth * SCROLL_STEP_RATIO) * direction;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({
        left: delta,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
}

/**
 * @param {HTMLElement} carousel - .filter-bar-carousel root
 */
function initFilterBarCarousel(carousel) {
    if (!carousel || carousel.getAttribute(INIT_ATTR) === '1') {
        return;
    }

    var track = carousel.querySelector('.filter-bar-carousel__track');
    var prev = carousel.querySelector('.filter-bar-carousel__btn--prev');
    var next = carousel.querySelector('.filter-bar-carousel__btn--next');
    if (!track) {
        return;
    }

    carousel.setAttribute(INIT_ATTR, '1');

    if (prev) {
        prev.addEventListener('click', function () {
            scrollTrack(track, -1);
        });
    }
    if (next) {
        next.addEventListener('click', function () {
            scrollTrack(track, 1);
        });
    }

    track.addEventListener('scroll', function () {
        updateNavState(carousel);
    }, { passive: true });

    carousel.addEventListener('keydown', function (e) {
        if (!carousel.contains(e.target) || (e.target.closest && e.target.closest('.filter-bar-carousel__btn'))) {
            return;
        }
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            scrollTrack(track, -1);
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            scrollTrack(track, 1);
        } else if (e.key === 'Home') {
            e.preventDefault();
            track.scrollTo({ left: 0, behavior: 'auto' });
        } else if (e.key === 'End') {
            e.preventDefault();
            track.scrollTo({ left: track.scrollWidth, behavior: 'auto' });
        }
    }, true);

    if (typeof window.ResizeObserver !== 'undefined') {
        var resizeObserver = new window.ResizeObserver(function () {
            updateNavState(carousel);
        });
        resizeObserver.observe(track);
        track.querySelectorAll('.btn').forEach(function (btn) {
            resizeObserver.observe(btn);
        });
    }

    window.addEventListener('resize', function () {
        scheduleNavUpdate(carousel);
    });

    scheduleNavUpdate(carousel);
}

/**
 * Initialize or refresh all filter bar carousels (e.g. after PLP load, Ajax filter, or resize).
 */
function initAll() {
    document.querySelectorAll('[data-filter-bar-carousel]').forEach(function (carousel) {
        var track = carousel.querySelector('.filter-bar-carousel__track');
        if (!track) {
            return;
        }

        rearrangeFilterButtons(track);

        if (carousel.getAttribute(INIT_ATTR) === '1') {
            scheduleNavUpdate(carousel);
            return;
        }

        initFilterBarCarousel(carousel);
    });
}

/* global $ */
if (typeof $ !== 'undefined' && $.fn && $.fn.on) {
    $(document.body).on('filterBarCarousel:init', initAll);
}

module.exports = {
    init: initAll,
    initElement: initFilterBarCarousel,
    clearInitFlags: clearInitFlags,
    rearrangeFilterButtons: rearrangeFilterButtons,
    focusRefinementBlock: focusRefinementBlock,
    focusFirstRefinementSection: focusFirstRefinementSection,
    focusFilterBarTrigger: focusFilterBarTrigger,
    focusDrawerCloseApply: focusDrawerCloseApply,
    scheduleFocusDrawerCloseApplyAfterAjax: scheduleFocusDrawerCloseApplyAfterAjax,
    scheduleFocusRefinementBlock: scheduleFocusRefinementBlock
};
